import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Skeleton } from "@/components/ui/skeleton";
import { useOrganizationStore } from "@/store/organization";

/** Switches the active organization using the existing session transition. */
export const OrganizationDropdown = () => {
  const organizations = useOrganizationStore((s) => s.organizations);
  const isLoading = useOrganizationStore((s) => s.isLoading);
  const organization = useOrganizationStore((s) => s.organization);
  const setOrganization = useOrganizationStore((s) => s.setOrganization);
  const isSwitchingOrganization = useOrganizationStore((s) => s.isSwitching);

  const handleChange = (value: string) => {
    const organization = organizations.find((org) => org.id === value);
    if (!organization) return;
    void setOrganization(organization);
  };

  if (isLoading || !organization) {
    return <Skeleton className="h-12 w-full" />;
  }

  return (
    <Select
      value={organization.id}
      onValueChange={handleChange}
      disabled={isSwitchingOrganization}
    >
      <SelectTrigger
        aria-label={`Organization: ${organization.name}`}
        className="h-12! w-full min-w-0 border-transparent bg-transparent px-2 shadow-none hover:bg-background"
      >
        <span
          aria-hidden="true"
          className="flex size-8 shrink-0 items-center justify-center rounded-lg border bg-background text-xs text-muted-foreground"
        >
          {organization.name.charAt(0).toUpperCase()}
        </span>
        <span className="min-w-0 flex-1 truncate text-left text-[13px] font-semibold">
          <SelectValue placeholder="Select" />
        </span>
      </SelectTrigger>
      <SelectContent>
        {organizations?.map((org) => (
          <SelectItem key={org.id} value={org.id}>
            {org.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
